export const BILLING_CYCLES = ['monthly', 'annual'] as const;
export type BillingCycle = (typeof BILLING_CYCLES)[number];

export const SUBSCRIPTION_STATUSES = [
  'trialing',
  'active',
  'past_due',
  'grace_read_only',
  'canceled',
  'paused',
] as const;
export type SubscriptionStatus = (typeof SUBSCRIPTION_STATUSES)[number];

export const ADDON_TYPES = ['one_time', 'recurring'] as const;
export type AddonType = (typeof ADDON_TYPES)[number];

export const CREDIT_METRICS = ['ai_render', 'cut_optimization'] as const;
export type CreditMetric = (typeof CREDIT_METRICS)[number];

export const ADDON_ENTITLEMENT_KEYS = [
  'ai_render_pack',
  'cut_optimization_pack',
  'extra_seat',
  'contract_generation',
  'digital_signature',
] as const;
export type AddonEntitlementKey = (typeof ADDON_ENTITLEMENT_KEYS)[number];

export const PLATFORM_ADMIN_ROLES = ['super', 'billing', 'support'] as const;
export type PlatformAdminRole = (typeof PLATFORM_ADMIN_ROLES)[number];

export const BILLABLE_ORGANIZATION_ROLES = ['admin', 'seller'] as const;
export type BillableOrganizationRole = (typeof BILLABLE_ORGANIZATION_ROLES)[number];

export interface PlanLimits {
  maxProjects?: number;
  maxSeats?: number;
  maxRendersPerMonth?: number;
  maxCutOptimizationsPerMonth?: number;
}

export interface PlanFeatures {
  aiRender?: boolean;
  cutOptimization?: boolean;
  ponttaExport?: boolean;
  catalogAdmin?: boolean;
  contractGeneration?: boolean;
  digitalSignature?: boolean;
}

export type OrganizationAccessMode = 'full' | 'read_only' | 'blocked';

export const DEFAULT_GRACE_PERIOD_DAYS = 5;
export const DEFAULT_TRIAL_DAYS = 14;

export const PLATFORM_SETTING_KEYS = {
  gracePeriodDays: 'gracePeriodDays',
  defaultTrialDays: 'defaultTrialDays',
  readOnlyOnPastDue: 'readOnlyOnPastDue',
} as const;
